/**
 * shop.binho.io — the only hand-written script on this domain.
 *
 * Everything else running here is the site's own code, synced verbatim by
 * sync-from-site.mjs. This file covers the one behaviour that lives in Astro's
 * hoisted module bundle, which cannot be loaded cross-origin (a module script
 * needs CORS headers www.binho.io does not send).
 *
 * FOOTER TERMINAL
 * The site ships an empty <span data-full-text="Ship Better Hardware, Faster.">
 * and types the text in from that bundle. Without the bundle the span stayed
 * empty and the tagline never appeared.
 *
 * The sync writes the text into the element, so it is already present and visible
 * before this runs. This only re-animates it — which means, unlike the original,
 * the tagline survives JavaScript being blocked, this file failing to load, or a
 * crawler that does not execute scripts. The animation is decoration; the text is
 * content, and content should not depend on decoration.
 */
(function () {
  'use strict';

  var TYPE_MS = 45;

  function typeOut(el) {
    var text = el.getAttribute('data-full-text') || el.textContent || '';
    if (!text) return;

    el.textContent = '';
    var i = 0;

    (function step() {
      el.textContent = text.slice(0, ++i);
      if (i < text.length) setTimeout(step, TYPE_MS);
    })();
  }

  function init() {
    var terminals = document.querySelectorAll('[data-full-text]');
    if (!terminals.length) return;

    // Respect the OS setting. The text is already in the DOM, so honouring this
    // costs nothing — it just stays put rather than animating.
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // No IntersectionObserver (or reduced motion): leave the text as-is. Never
    // clear it — an un-animated tagline is fine, a blank one is a bug.
    if (still || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        typeOut(entry.target);
      });
    }, { threshold: 0.4 });

    Array.prototype.forEach.call(terminals, function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
